var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.961,
    height: 21.74,
    viewBox: "0 0 24.961 21.74",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047",
    transform: "translate(16728 -1760)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2750",
    "data-name": "Rectangle 2750",
    width: 24.96,
    height: 21.74,
    transform: "translate(-16728 1760)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3045",
    "data-name": "Group 3045",
    transform: "translate(30.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(-16750 1760)",
    fill: "#2555ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26896",
    "data-name": "Path 26896",
    d: "M127.965,239.908c-2.131-.178-3.984,0-5.581,1.321-2.674,2.142-2.159,5.025-2.159,8.553a1.71,1.71,0,0,0,1.707,1.707c10.288,0,10.7.332,11.308-1.019.2-.457.145-.312.145-4.682A5.909,5.909,0,0,0,127.965,239.908Z",
    transform: "translate(-16872.326 1530.214)",
    fill: "#2555ef"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.549edc9c.svg";
export { ForwardRef as ReactComponent };